import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/banner-home-1920.mp4")